import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ListModule } from 'app/shared/components/list/list.module';
import { PaginationModule } from 'app/shared/components/pagination/pagination.module';
import { ToolbarModule } from 'app/shared/components/toolbar/toolbar.module';
import { TooltipModule } from 'app/shared/components/tooltip/tooltip.module';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ButtonModule } from '../../../button/button.module';
import { InputBoxModule } from '../../../input-box/input-box.module';
import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';
import { TextAreaModule } from '../../../text-area/text-area.module';
import { SelectObjectsTableModule } from '../select-objects-table/select-objects-table.module';
import { EventsRegisterComponent } from './events-register.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ScrollViewModule,
    InputBoxModule,
    TextAreaModule,
    ButtonModule,
    ListModule,
    PaginationModule,
    ToolbarModule,
    TooltipModule,
    SelectObjectsTableModule,
    BlockModalDragModule,
  ],
  declarations: [EventsRegisterComponent],
  exports: [EventsRegisterComponent],
})
export class EventsRegisterModule {}
